import { commandResponseSchema } from "./api-client.ts"
import { resolveUserRoute } from "./routes.ts"
import type { RouteAction } from "./route-actions.ts"

const receiptId = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const safeNextRoute = (value: string): string | null => {
  if (!value.startsWith("/") || value.startsWith("//")) return null
  const parsed = new URL(value, "https://cashhub.local")
  if (parsed.origin !== "https://cashhub.local") return null
  for (const key of ["quoteId", "resourceId"] as const) {
    const identifier = parsed.searchParams.get(key)
    if (identifier !== null && !receiptId.test(identifier)) return null
  }
  const route = `${parsed.pathname}${parsed.search}`
  return resolveUserRoute(parsed.pathname) === null ? null : route
}

export const safeReceiptRoute = (value: unknown, action: RouteAction): string | null => {
  const result = commandResponseSchema.safeParse(value)
  if (!result.success) return null
  const receipt = result.data
  const route = safeNextRoute(receipt.nextRoute)
  if (route === null) return null
  const parsed = new URL(route, "https://cashhub.local")
  if (resolveUserRoute(parsed.pathname)?.id !== action.receipt.routeId) return null
  if (receipt.kind === "static") return action.receipt.kind === "static" ? route : null
  if (action.receipt.kind === "static") return null
  const routedResource = parsed.searchParams.get("resourceId") ?? parsed.searchParams.get("quoteId") ?? parsed.pathname.split("/").at(-1)
  if (routedResource !== receipt.resourceId) return null
  return action.receipt.kind === "generated-resource" || action.receipt.resourceId === receipt.resourceId ? route : null
}
